import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Box,
  Card as MuiCard,
  CardContent,
  styled,
  IconButton,
} from '@mui/material';
import { Row } from 'components/Layout';
import { isArray } from 'lodash';
import React, { ReactNode } from 'react';

const Container = styled(Box)({
  width: '100%',
});
const ScrollableArea = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowY: 'auto',
  paddingBottom: theme.spacing(theme.spacingSizes.lg),
}));

const CardContainer = styled(Box)({
  position: 'relative',
  height: '100%',
});

const Card = styled(MuiCard)({
  flexGrow: 0,
  flexShrink: 0,
  overflow: 'hidden',
});

const ExpandButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translate(-50%, 50%)',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[300]}`,
  padding: theme.spacing(theme.spacingSizes.xxs),

  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));

const sizes = {
  md: 500,
};

type Props = {
  cardSize: 'md';
  onToggle: () => void;
  isExpanded?: boolean;
  children: ReactNode | Array<ReactNode>;
};

const CardsListWithPreview: React.FC<Props> = ({
  cardSize,
  children,
  onToggle,
  isExpanded = false,
}) => {
  const handleToggle = () => {
    onToggle();
  };

  const childrenElements = isArray(children) ? children : [children];

  return (
    <Container>
      <ScrollableArea>
        <Row fullWidth spacing="sm">
          {childrenElements.map((element, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <CardContainer key={index}>
              <Card
                sx={{
                  width: sizes[cardSize],
                  maxHeight: isExpanded ? 'none' : 256,
                }}
                variant="outlined"
              >
                <CardContent>{element}</CardContent>
              </Card>
              <ExpandButton size="small" onClick={handleToggle}>
                {isExpanded ? (
                  <ExpandLess fontSize="small" />
                ) : (
                  <ExpandMore fontSize="small" />
                )}
              </ExpandButton>
            </CardContainer>
          ))}
        </Row>
      </ScrollableArea>
    </Container>
  );
};

export default CardsListWithPreview;
